import React from 'react';
import { Navigate } from 'react-router-dom';
import { lazy } from 'react';
import Loadable from '../components/Loadable';
import ProtectedRoute from './ProtectedRoute';
import DashboardLayout from '../layouts/DashboardLayout';
import respondentMenuItems from '../menu-items/respondent';

const MinimalLayout = Loadable(lazy(() => import('../layouts/MinimalLayout')));
const Login = Loadable(lazy(() => import('../pages/Login')));
const DashboardPage = Loadable(lazy(() => import('../pages/Dashboard')));
const RecordingsPage = Loadable(lazy(() => import('../pages/Recordings')));
const RespondentCases = Loadable(lazy(() => import('../pages/RespondentCases')));
const Lobby = Loadable(lazy(() => import('../pages/Lobby')));
const LobbyRoom = Loadable(lazy(() => import('../pages/LobbyRoom')));
const MeetingGateway = Loadable(lazy(() => import('../pages/Meeting/MeetingGateway')));
const MeetRedirect = Loadable(lazy(() => import('../pages/MeetRedirect')));
const ErrorElement = Loadable(lazy(() => import('../pages/Error/ErrorElement')));

const MainRoutes = {
  path: '/',
  element: <MinimalLayout />,
  errorElement: <ErrorElement />,
  children: [
    {
      index: true,
      element: <Login />,
    },
    {
      path: 'dashboard',
      element: <ProtectedRoute><DashboardLayout /></ProtectedRoute>,
      children: [
        {
          index: true,
          element: <DashboardPage />,
        },
      ],
    },
    {
      path: 'recordings',
      element: <ProtectedRoute><DashboardLayout /></ProtectedRoute>,
      children: [
        {
          index: true,
          element: <RecordingsPage />,
        },
      ],
    },
    {
      path: 'respondent',
      element: <ProtectedRoute><DashboardLayout menuItems={respondentMenuItems} /></ProtectedRoute>,
      children: [
        {
          index: true,
          element: <Navigate to="/respondent/cases" replace />,
        },
        {
          path: 'cases',
          element: <RespondentCases />,
        },
      ],
    },
    {
      path: 'lobby/:roomToken',
      element: <Lobby />,
    },
    {
      // Dual-room lobby media room (FA1). Unprotected, matching /lobby.
      // The component redirects internally when the feature flag is off.
      path: 'lobby-room/:roomToken',
      element: <LobbyRoom />,
    },
    {
      path: 'meet/:token',
      element: <MeetRedirect />,
    },
    {
      path: 'meeting/:roomToken',
      element: <MeetingGateway />,
    },
    {
      path: '*',
      element: <ErrorElement />,
    },
  ],
};

export default MainRoutes;
